import { render, staticRenderFns } from "./ValueTpl.vue?vue&type=template&id=237d4e42"
import script from "./ValueTpl.vue?vue&type=script&lang=js"
export * from "./ValueTpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports